const MAP = {
  overdue: { label: "OVERDUE", color: "#DA1E28" },
  pending: { label: "PENDING", color: "#F1C21B" },
  in_progress: { label: "IN PROGRESS", color: "#0F62FE" },
  submitted: { label: "SUBMITTED", color: "#24A148" },
  exempt:  { label: "EXEMPT",  color: "#8D8D8D" },
};

export default function StatusBadge({ status }) {
  const s = MAP[status] || { label: String(status || "").toUpperCase(), color: "#737373" };
  return (
    <span className="inline-flex items-center gap-2 border border-border rounded-none px-2 py-0.5 font-mono text-[10px] tracking-widest"
          data-testid={`status-badge-${status}`}>
      <span className="inline-block h-2 w-2 rounded-full" style={{ background: s.color }} />
      {s.label}
    </span>
  );
}
